module.exports = __webpack_public_path__ + "999809e13b25381eafe4e6ddae4d3850.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ice-powers.png
// module id = 2400
// module chunks = 0